import React, { useCallback } from 'react'
import { useField } from 'formik'

import { ThailandAddressType } from '@components/interfaces/AddressSearchSelect'
import {
  WithAddressSearchSelectFieldProps,
  AddressSearchSelectFieldProps,
} from './interface'

export function withAddressSearchSelectField(
  Component: React.FC<AddressSearchSelectFieldProps>
) {
  function WithAddressSearchSelectField({
    name,
    addressKey,
    label,
    labelClassName,
    placeholder,
    disabled,
    onChange,
  }: WithAddressSearchSelectFieldProps) {
    const [field, { touched, error }, { setValue }] = useField(name)

    const handleChange = useCallback(
      (value: ThailandAddressType) => {
        setValue(value[addressKey])

        if (onChange) {
          onChange(value)
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [addressKey]
    )

    const componentProps = {
      name,
      addressKey,
      label,
      labelClassName,
      placeholder,
      touched,
      error,
      disabled,
      handleChange,
    }

    return <Component {...field} {...componentProps} />
  }

  return WithAddressSearchSelectField
}
